// ==========================================================================
// Supported languages - single source of truth
// ==========================================================================
//
// Kept in its own module so the locale list is not derived from whichever
// catalogs happen to be bundled. Before ENG-949 the list came from
// Object.keys(resources), which meant adding a language required a loader
// change; catalogs now load at runtime, so this list is the only place a
// locale is declared.

export const LANGUAGES = ['en', 'am', 'es', 'sw'] as const;

export type Language = (typeof LANGUAGES)[number];

export const isSupportedLanguage = (value: unknown): value is Language =>
  typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value);

// A `?lang=` override lets QA, translators, and non-technical reviewers preview
// any language by URL (ENG-1061). Normalises like the rest of the stack:
// lower-cased and reduced to the base subtag, so `es-CO` and `AM` both resolve.
// Returns null for a missing or unsupported value so the caller falls through
// to its normal detection.
export const localeFromSearch = (search: string): Language | null => {
  const raw = new URLSearchParams(search).get('lang');
  if (!raw) return null;

  const base = raw.trim().toLowerCase().split('-')[0];

  return isSupportedLanguage(base) ? base : null;
};
